import { animated, useReducedMotion, useSpring } from '@react-spring/web';
import cx from 'classnames';
import React from 'react';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactElement;
  in?: boolean;
  onClick?: any;
  onEnter?: (node: HTMLElement, isAppearing: boolean) => void;
  onExited?: (node: HTMLElement, isAppearing: boolean) => void;
  ownerState?: any;
}

export const Slide = React.forwardRef<HTMLDivElement, Props>(function Fade(props, ref) {
  const { children, in: open, onClick, onEnter, onExited, ownerState, className, ...other } = props;
  // Respect prefers-reduced-motion: jump straight to the end state instead of
  // sliding. An accessibility fix first — and it also makes the modal settle
  // immediately under test, where a mid-slide element is "not stable" and a
  // click on it fails for reasons that have nothing to do with the app.
  const prefersReducedMotion = useReducedMotion();
  const style = useSpring({
    immediate: prefersReducedMotion,
    from: { transform: 'translateX(150%)' },
    to: { transform: open ? 'translateX(0%)' : 'translateX(150%)' },
    onStart: () => {
      if (open && onEnter) {
        onEnter(null as any, true);
      }
    },
    onRest: () => {
      if (!open && onExited) {
        onExited(null as any, true);
      }
    },
  });

  return (
    <animated.div
      ref={ref}
      style={style}
      {...other}
      className={cx('h-screen -z-50 pointer-events-none focus:outline-hidden', className)}
    >
      {React.cloneElement(children, { onClick })}
    </animated.div>
  );
});
